import _, { includes, mergeWith, uniqBy } from 'lodash';
import keyBy from 'lodash/keyBy';
import merge from 'lodash/merge';
import values from 'lodash/values';
import { ENV } from "./EWindow";

import { store } from '@/stores/dataStore/reduxStore/store';
import Random from './random';


export function getConfigFromWindowBrowser(name: ENV) {
    if (typeof document === "undefined") {
        // running in a server environment
        return null
    } else {
        // running in a browser environment
        return (window as any)?.env?.[name]
    }
}

export const TabID = new Date().getTime() + "_" + Random.randomIdChars(6)
class CommonUtils {
    /**
     * 
     * @param arr1 
     * @param arr2 
     * @param key 
     * @returns 
     */
    static mergeArrayByKey = (arr1: any, arr2: any, key: string) => {
        let merged = merge(keyBy(arr1, key), keyBy(arr2, key));
        let arrRes = values(merged);
        return arrRes
    }

    static getTokenCurr = (maxLength?: number) => {
        const state = store.getState();
        let token = state.app.token != null ? state.app.token : null;
        if (token && maxLength) {
            token = token.substr(0, maxLength)
        }
        return token;
    }

    static mergeArrayByOnlyKeyArr1 = (arr1: any, arr2: any, key: string) => {
        const arrRes = arr1.map((item1: any) => {
            // Tìm phần tử trong array2 có cùng id
            const item = arr2.find((item2: any) => item2[key] === item1[key]);
            // Nếu tìm thấy, merge cả hai phần tử lại
            return item ? merge({}, item1, item) : item1;
        });
        return arrRes
    }

    static transformSymbolsDataInstruments = (data: any) => {
        const exchanges: any[] = [];
        const symbols = [];
        const symbolWithIndex: any = {};
        const symbolInfoForInstrument: any = {};
        const symbolInfos = data;
        for (let i = 0; i < symbolInfos.length; i++) {
            const symbolInfo = symbolInfos[i];
            const { symbol, FullName, exchange, StockType } = symbolInfo;
            if (exchange === '' || exchange === undefined) {
                continue;
            }

            if (!includes(exchanges, exchange)) {
                exchanges.push(exchange);
            }
            const convertedInfo = {
                id: symbol,
                exchange: exchange,
                desc: FullName,
                stockType: StockType,
                ...symbolInfo
            };
            symbolInfoForInstrument[symbol] = this.processJSONAllStock(convertedInfo);
            symbolWithIndex[symbol] = convertedInfo;
            symbols.push(convertedInfo);
        }
        return { exchanges: exchanges, symbols: symbols, symbolWithIndex, symbolInfoForInstrument };
    };

    static processJSONAllStock(proto: any) {
        var object = {
            Id: proto.id,
            SB: proto.symbol,
            SI: proto.StockId,
            FN: proto.FullName || "",
            TD: proto.tradingdate,
            FC: proto.FloorCode,
            ST: proto.StockType,
            CL: proto.ceiling || "",
            FL: proto.floor,
            RE: proto.reference,
            B3: proto.bidPrice3,
            V3: proto.bidVol3 || "",
            B2: proto.bidPrice2,
            V2: proto.bidVol2 || "",
            B1: proto.bidPrice1,
            V1: proto.bidVol1 || "",
            CP: proto.closePrice,
            // P4A: proto.price4Asset, // Không lấy trường này từ api instrument
            CV: proto.closeVol || "",
            CH: proto.change,
            S1: proto.offerPrice1,
            U1: proto.offerVol1 || "",
            S2: proto.offerPrice2,
            U2: proto.offerVol2 || "",
            S3: proto.offerPrice3,
            U3: proto.offerVol3 || "",
            TT: proto.totalTrading || "",
            TV: proto.totalTradingValue || "",
            AP: proto.averagePrice,
            OP: proto.open,
            HI: proto.high,
            LO: proto.low,
            FB: proto.foreignBuy || "",
            FS: proto.foreignSell || "",
            FR: proto.foreignRemain || "",
            SS: proto.Status,
            EX: proto.exchange,
            OI: proto.openInterest,
            LTD: proto.lastTradingDate,
            ULS: proto.underlyingSymbol || "",
            ULP: proto.underlyingPrice,
            IN: proto.IssuerName,
            MD: proto.MaturityDate,
            CHP: proto.changePercent,
            percent: Number(proto.changePercent) * 1000 || 0,
            EP: proto.ExercisePrice,
            ER: proto.ExerciseRatio,
            FO: proto.foreignRoom || "",
            PMP: proto.PT_MATCH_PRICE,
            PMQ: proto.PT_MATCH_QTTY,
            PTQ: proto.PT_TOTAL_TRADED_QTTY,
            PTV: proto.PT_TOTAL_TRADED_VALUE,
            PP: proto.PRIOR_PRICE,
            TO: proto.TOTAL_OFFER_QTTY,
            TB: proto.TOTAL_BID_QTTY,
            FT: proto.FundType || "",
            BEP: 0,
            s: 0,
            ts: 0,
        };
        // if (object.CHP && object.CHP != 0) {
        //     object.percent = object.CHP * 1000
        //     // object.percent1 = ((Number(object.CH) / Number(object.RE)) * 100 * 1000) // tính % thay đổi
        // }

        object.BEP = this.calBreakEvenPoint(object.EP, object.CP, object.ER);
        //object.ts = Date.now();
        object.s = proto.s || 0; // Haki.: mặc định = 0 nếu undefined
        object.ts = proto.ts || 0; // Haki.: mặc định = 0 nếu undefined
        return object;
    }

    static calBreakEvenPoint(exercisePrice: any, closePrice: any, exerciseRatio: any) {
        let breakEventPoint = 0;
        if (Number.parseFloat(exercisePrice) && Number.parseFloat(closePrice) && exerciseRatio) {
            breakEventPoint = (exercisePrice ? Number.parseFloat(exercisePrice) : 0) + ((closePrice ? closePrice : 0) * (exerciseRatio ? Number.parseFloat(exerciseRatio.split(":")[0]) : 0));
        }
        return breakEventPoint
    }

    static divide(x: any, y: any) {
        if (isNaN(x)) return x;
        if (!y || x == null) return null;
        return x / y;
    };

    static roundToTwo(x: number, y: number) {
        if (isNaN(x)) return x;
        if (!y || x == null) return null;
        return ((x / y)).toFixed(2)
    }


    static mergeArraysByKey = (array1: any, array2: any, key: string) => {
        // Chuyển đổi mỗi mảng thành một đối tượng được sắp xếp bởi `id`
        const array1ById = keyBy(array1, key);
        const array2ById = keyBy(array2, key);
        // Hợp nhất hai đối tượng dựa trên `id`
        const mergedObject = mergeWith({}, array1ById, array2ById, (objValue, srcValue) => {
            if (Array.isArray(objValue)) {
                // console.log("mergeArraysByKey.:mergedObject", objValue, srcValue, objValue.concat(srcValue), uniqBy(objValue.concat(srcValue), key))
                return uniqBy(objValue.concat(srcValue), key);
            }
        });
        // console.log("mergeArraysByKey.:", array1, array2, values(mergedObject))
        return values(mergedObject);
    };

    static formatNumber = (value: number): string => {
        return Number(value.toFixed(2)).toString()
    }

    static censorName = (name: string): string => {
        let parts = name.split(' ');
        if (parts.length < 2) return name;
        let firstName = parts[0];
        let censoredLastName = parts.slice(1).map(word => _.repeat('*', word.length)).join(' ');
        return `${firstName} ${censoredLastName}`;
    }

    static getTabID() {
        return TabID
    }
}





export default CommonUtils;
